import Vue from 'vue'
import VueRouter from 'vue-router'
import SzyIndex from '../views/szyIndex/szyIndex.vue' /*首页 */

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'SzyIndex',
    component: SzyIndex,
  },
  {
    path:'/publicpage',
    name:'PublicPage',
    component:()=>import('@/views/PublicPage/index.vue'),
    // children: [
    //   {
    //     path: 'index',
    //     component: () => import('@/views/index'),
    //     name: 'Index',
    //     meta: { title: '首页', icon: 'dashboard', affix: true }
    //   }
    // ]
  },
  {
    path:'/informationdisclosure',
    name:'InformationDisclosure',
    component:()=>import('@/views/informationDisclosure/index.vue'),
  },
  {
    path:'/subsidiaryCompanies',
    name:'SubsidiaryCompanies',
    component:()=>import('@/views/subsidiaryCompanies/index.vue'),
  },
  {
    path:'/partybuildingPage',
    name:'partybuildingPage',
    component:()=>import('@/views/partybuildingPage/index.vue'),
  },
  {
    path:'/specialcolumn',
    name:'specialColumn',
    component:()=>import('@/views/specialcolumn/index.vue'),
  },
  {
    path:'/speciallist',
    name:'specialList',
    component:()=>import('@/views/speciallist/index.vue'),
  },
  {
    path:'/searchpage',
    name:'searchPage',
    component:()=>import('@/views/searchPage/index.vue'),
  },
  {
    path:'/leaderspeech',
    name:'leaderSpeech',
    component:()=>import('@/views/leaderSpeech/index.vue'),
  },
  {
    path:'/events',
    name:'eventsIndex',
    component:()=>import('@/views/eventsIndex/index.vue'),
  },
  {
    path:'/area',
    name:'areaIndex',
    component:()=>import('@/views/areaIndex/index.vue'),
  },
  {
    path:'/contact',
    name:'contactIndex',
    component:()=>import('@/views/contactIndex/index.vue'),
  },
  {
    path:'/five',
    name:'fiveIndex',
    component:()=>import('@/views/fiveIndex/index.vue'),
  },
  {
    path:'/memo',
    name:'memoIndex',
    component:()=>import('@/views/memoIndex/index.vue'),
  },
  {
    path:'/productservice',
    name:'productService',
    component:()=>import('@/views/productService/index.vue'),
  },
  {
    path:'/error_404',
    name:'error_404',
    component:()=>import('@/views/error/error_404.vue'),
  }
]




const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to,from,savePosition){
    if(savePosition){
      //解决页面从列表页跳转到详情页返回,初始在原来位置
      return savePosition
    }else{
      //解决页面跳转后页面高度和前一个页面高度一样
      return {x:0,y:0}
    }
  }
})
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) { // 如果路由不匹配任何路由规则，则重定向到404页面
    next({ path: '/error_404' }); // 确保你的路由表中有一个路径为'/404'的路由指向NotFound组件
  } else {
    next(); // 确保一定要调用 next()
  }
});
export default router